const colorData = {
  progress__bubble: {
    active: {
      color: "#afafaf",
      backgroundColor: "#afafaf",
      borderColor: "#afafaf",
    },
    inactive: {
      color: "#afafaf",
      backgroundColor: "#afafaf",
      borderColor: "#afafaf",
    },
    completed: {
      color: "#27ae60",
      borderColor: "#27ae60",
      backgroundColor: "#27ae60",
    },
  },
  progress__label: {
    active: {
      color: "#e74c3c",
    },
    inactive: {
      color: "#34495e",
    },
    completed: {
      color: "#27ae60",
    },
  },
  progress__bridge: {
    active: {
      backgroundColor: "#e74c3c",
    },
    inactive: {
      backgroundColor: "#34495e",
    },
    completed: {
      backgroundColor: "#27ae60",
    },
  },
}

export { colorData }
